export const SEND_CONTACT_FORM_ATTEMPT = 'SEND_CONTACT_FORM_ATTEMPT';
export type SEND_CONTACT_FORM_ATTEMPT = typeof SEND_CONTACT_FORM_ATTEMPT;

export const SEND_CONTACT_FORM_SUCCESS = 'SEND_CONTACT_FORM_SUCCESS';
export type SEND_CONTACT_FORM_SUCCESS = typeof SEND_CONTACT_FORM_SUCCESS;

export const SEND_CONTACT_FORM_FAILURE = 'SEND_CONTACT_FORM_FAILURE';
export type SEND_CONTACT_FORM_FAILURE = typeof SEND_CONTACT_FORM_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/contact-form/send/Types.tsx